export const iconFontAwesomeCommunicationMobileScreenButton = (
	<i className="fa-solid fa-mobile-screen-button"></i>
);
